import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Checkbox, InputGroup, Select, Textarea } from 'components/FormComponents';

export const CancelCheckModal = ({
  visible,
  checkTitle = '',
  onClose = () => {},
  onCancel = () => {},
}) => {
  const { t } = useTranslation();
  const [noChargeReason, setNoChargeReason] = useState('other');
  const [reason, setReason] = useState('');
  const [useCustomEmailMessage, setUseCustomEmailMessage] = useState(false);
  const [emailMessage, setEmailMessage] = useState('');

  useEffect(() => {
    if (visible) {
      setNoChargeReason('other');
      setReason('');
      setUseCustomEmailMessage(false);
      setEmailMessage('');
    }
  }, [visible]);

  const handleCancel = () => {
    const payload = {
      no_charge_reason: noChargeReason,
      reason: reason.trim() || null,
    };
    if (useCustomEmailMessage) {
      payload.email_message = emailMessage.trim() || null;
    }
    onCancel(payload);
  };

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('admin.candidate.check.cancel.confirmation', { title: checkTitle })}
      small>
      <div className="d-flex flex-column u-gap-medium">
        <InputGroup title={t('admin.candidate.check.cancel.reason')}>
          <Select
            name="no_charge_reason"
            value={noChargeReason}
            onChange={event => setNoChargeReason(event.target.value)}>
            <Select.Item value="other">{t('admin.candidate.check.cancel.reasonOther')}</Select.Item>
            <Select.Item value="no_ssn">
              {t('admin.candidate.check.cancel.reasonNoSsn')}
            </Select.Item>
            <Select.Item value="below_min_age">
              {t('admin.candidate.check.cancel.reasonBelowMinAge')}
            </Select.Item>
            <Select.Item value="no_required_address">
              {t('admin.candidate.check.cancel.reasonNoRequiredAddress')}
            </Select.Item>
          </Select>
        </InputGroup>
        <InputGroup title={t('admin.candidate.check.cancel.note')} optional>
          <Textarea
            name="reason"
            placeholder={t('admin.candidate.check.cancel.reasonPlaceholder')}
            rows={4}
            inputProps={{
              value: reason,
              onChange: e => setReason(e.target.value),
            }}
          />
        </InputGroup>
        <Checkbox
          name="use_custom_email_message"
          checked={useCustomEmailMessage}
          label={t('admin.candidate.check.cancel.useCustomEmailMessage')}
          onChange={setUseCustomEmailMessage}
        />
        {useCustomEmailMessage && (
          <InputGroup title={t('admin.candidate.check.cancel.emailMessage')} optional>
            <Textarea
              name="email_message"
              placeholder={t('admin.candidate.check.cancel.emailMessagePlaceholder')}
              rows={4}
              inputProps={{
                value: emailMessage,
                onChange: e => setEmailMessage(e.target.value),
              }}
            />
          </InputGroup>
        )}
        <div className="d-flex u-gap justify-content-end u-margin-top--small">
          <Button type="secondary" onClick={onClose}>
            {t('common.no')}
          </Button>
          <Button type="delete" onClick={handleCancel}>
            {t('common.yes')}
          </Button>
        </div>
      </div>
    </AnimatedModal>
  );
};
